export default "__VITE_PUBLIC_ASSET__fe614167__"